module.exports = __webpack_public_path__ + "static/img/18018C_1_C_20210117_LC.06ed3f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18018C_1_C_20210117_LC.png
// module id = lk5J
// module chunks = 0